import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "row no-gutters pt-45 px-sm-5 px-3" };
const _hoisted_2 = { class: "loginSection mx-auto pt-2 px-sm-45 px-0 bg-white font6-responsive" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("h2", { class: "h5 text-left" }, "Registrieren", -1);
const _hoisted_4 = { class: "row text-left pb-45" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "font7-responsive pt-3" }, " Wir benötigen deine E-Mail-Adresse, um dir Updates zu deinem Kauf oder Verkauf zu senden. ")
], -1);
const _hoisted_6 = { class: "col-12 form-group mb-0" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("button", {
    class: "buttonBase buttonGreen w-100 mb-45 font6-responsive [ track_start-register ]",
    type: "button"
}, " Registrieren mit E-Mail ", -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("p", { class: "font7-responsive text-center" }, "oder registriere Dich mit", -1);
const _hoisted_9 = /*#__PURE__*/ _createStaticVNode("<div class=\"col-4 text-center\"><a href=\"/auth/google\" title=\"Google Login\" class=\"[ track_google-login ]\"><div class=\"border rounded p-1\"><img src=\"/images/icons/google.png\" alt=\"Google\" style=\"max-width:48px;\" data-max-width=\"48\"></div></a></div><div class=\"col-4 text-center\"><a href=\"/auth/facebook\" title=\"Facebook Login\" class=\"[ track_facebook-login ]\"><div class=\"border rounded p-1\"><img src=\"/images/icons/facebook_rounded.png\" alt=\"Facebook\" style=\"max-width:48px;\" data-max-width=\"48\"></div></a></div><div class=\"col-4 text-center\"><a href=\"/auth/amazon\" title=\"Amazon Login\" class=\"[ track_amazon-login ]\"><div class=\"border rounded p-1\"><img src=\"/images/icons/amazon.png\" alt=\"Amazon\" style=\"max-width:48px;\" data-max-width=\"48\"></div></a></div>", 3);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("h2", { class: "h5 text-left mb-0" }, "Hast Du schon ein Konto?", -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("p", { class: "strong pb-3" }, "Hier anmelden:", -1);
const _hoisted_14 = { class: "row" };
const _hoisted_15 = ["onSubmit"];
const _hoisted_16 = { class: "col-12 pb-4" };
const _hoisted_17 = { class: "col-12 pb-4" };
const _hoisted_18 = { class: "col-12 pb-3" };
const _hoisted_19 = ["disabled"];
const _hoisted_20 = {
    key: 0,
    class: "icon-spin4 animate-spin"
};
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("p", { class: "text-left text-underline mb-45" }, [
    /*#__PURE__*/ _createElementVNode("a", {
        class: "font7-responsive link-in-text [ cy_forgotPasswordLink ] [ track_forgot-passwort ]",
        href: "/auth/passreset/request"
    }, " Passwort vergessen? ")
], -1);
import { ref } from 'vue';
import axios from 'axios';
import BaseInput from '@/components/Base/Forms/Inputs/BaseInput.vue';
import { emailRequiredRule, stringRequiredRule } from '@/helpers/ValidationRules';
import eventBus from '@/services/EventBus';
export default /*#__PURE__*/ _defineComponent({
    __name: 'LoginForm',
    setup(__props) {
        const customerEmail = ref('');
        const customerPassword = ref('');
        const showLoadingIndikator = ref(false);
        const emailValid = ref(false);
        const passwordMightBeValid = ref(false);
        function handleLoginRequest() {
            showLoadingIndikator.value = true;
            axios
                .post('/auth/login', {
                email: customerEmail.value,
                password: customerPassword.value,
            })
                .then(() => {
                showLoadingIndikator.value = false;
                eventBus.emit('openInfoPopup', {
                    icon: 'info',
                    headline: 'Login',
                    message: '<p class="px-2 mb-0 text-center">Du hast die erfolgreich angemeldet!</p>',
                });
                eventBus.emit('LoggedIn');
            })
                .catch((error) => {
                showLoadingIndikator.value = false;
                console.log(error);
                switch (error.response.status) {
                    case 401:
                    case 404:
                        eventBus.emit('openInfoPopup', {
                            icon: 'error',
                            headline: 'Eingabe korrekt?',
                            message: 'Dieses Konto ist nicht vorhanden oder gesperrt.',
                        });
                        break;
                    case 403:
                        eventBus.emit('openInfoPopup', {
                            icon: 'error',
                            headline: 'Eingabe korrekt?',
                            message: 'Bitte überprüfe noch einmal ob deine E-Mail und dein Passwort korrekt sind.',
                        });
                        break;
                    case 429:
                        eventBus.emit('openInfoPopup', {
                            icon: 'error',
                            headline: 'Zu viele Fehlversuche!',
                            message: 'Der Login wird für Dich aus Sicherheitsgründen für eine Stunde gesperrt.',
                        });
                        break;
                    default:
                        eventBus.emit('openInfoPopup', {
                            icon: 'error',
                            headline: 'Anmeldefehler!',
                            message: 'Leider ist ein Fehler bei der Anmeldung aufgetreten.',
                        });
                }
            });
        }
        return (_ctx, _cache) => {
            const _component_open_popup_button = _resolveComponent("open-popup-button");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("section", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_open_popup_button, { "popup-name": "openRegisterPopup" }, {
                                default: _withCtx(() => [
                                    _hoisted_7
                                ]),
                                _: 1
                            }),
                            _hoisted_8
                        ]),
                        _hoisted_9
                    ]),
                    _hoisted_12,
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("form", {
                            name: "login_form",
                            class: "w-100",
                            onSubmit: _withModifiers(handleLoginRequest, ["prevent"])
                        }, [
                            _createElementVNode("div", _hoisted_16, [
                                _createVNode(BaseInput, {
                                    placeholder: "E-Mail",
                                    modelValue: customerEmail.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((customerEmail).value = $event)),
                                    name: "email",
                                    rules: _unref(emailRequiredRule),
                                    class: "showValidationErrorsCssOverride",
                                    onChanged: _cache[1] || (_cache[1] = (event) => (emailValid.value = event.valid))
                                }, null, 8, ["modelValue", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                                _createVNode(BaseInput, {
                                    inputType: "password",
                                    placeholder: "Passwort",
                                    modelValue: customerPassword.value,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((customerPassword).value = $event)),
                                    name: "password",
                                    rules: _unref(stringRequiredRule),
                                    onChanged: _cache[3] || (_cache[3] = (event) => (passwordMightBeValid.value = event.valid)),
                                    class: "showValidationErrorsCssOverride"
                                }, null, 8, ["modelValue", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("button", {
                                    disabled: !(emailValid.value && passwordMightBeValid.value),
                                    class: _normalizeClass([{ buttonDisabled: !(emailValid.value && passwordMightBeValid.value) }, "buttonBase buttonBlue font6-responsive w-100 mb-3 [ track_direct-login ]"]),
                                    onClick: handleLoginRequest,
                                    id: "login",
                                    type: "submit"
                                }, [
                                    _createTextVNode(" Login "),
                                    (showLoadingIndikator.value === true)
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                                        : _createCommentVNode("", true)
                                ], 10, _hoisted_19),
                                _hoisted_21
                            ])
                        ], 40, _hoisted_15)
                    ])
                ])
            ]));
        };
    }
});
